import React, { useState } from 'react';
import { XIcon, PencilIcon, SparklesIcon } from 'lucide-react';
type StoryReviewModalProps = {
  userInput: {
    foundation: {
      title: string;
      ageGroup: string;
      storyArc: string;
    };
    character: {
      name: string;
      special: string;
      type: string;
      description: string;
    };
    structure: {
      beginning: string;
      middle: string;
      ending: string;
    };
    style: {
      tone: string;
      inspiration: string;
      special: string;
      illustrationStyle: string;
    };
  };
  onClose: () => void;
  onEdit: (section: string) => void;
  onConfirm: () => void;
};
export const StoryReviewModal = ({
  userInput,
  onClose,
  onEdit,
  onConfirm
}: StoryReviewModalProps) => {
  const [aiSuggestions, setAiSuggestions] = useState({
    title: "The Dragon's Special Dance",
    character: 'A shy but determined dragon who loves to express themselves through dance',
    plot: 'When the annual forest talent show approaches, our dragon must overcome their fear of performing in front of others. With help from woodland friends and lots of practice, they learn that being yourself is the greatest talent of all.'
  });
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-1048">
      <div className="bg-white rounded-2xl w-full max-w-3xl p-6" data-id="element-1049">
        <div className="flex items-center justify-between mb-6" data-id="element-1050">
          <h2 className="text-xl font-bold text-[#6B4B3E]" data-id="element-1051">
            Review Your Story
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-[#FFF0E6] rounded-full transition-colors" data-id="element-1052">
            <XIcon size={20} className="text-[#6B4B3E]" data-id="element-1053" />
          </button>
        </div>
        <div className="space-y-6" data-id="element-1054">
          {/* Your Input Section */}
          <div className="bg-[#FFF0E6] rounded-xl p-6" data-id="element-1055">
            <div className="flex items-center justify-between mb-4" data-id="element-1056">
              <h3 className="text-lg font-bold text-[#6B4B3E]" data-id="element-1057">Your Ideas</h3>
              <button onClick={() => onEdit('all')} className="flex items-center text-[#D4A088] hover:text-[#C28B73]" data-id="element-1058">
                <PencilIcon size={16} className="mr-1" data-id="element-1059" />
                <span data-id="element-1060">Edit</span>
              </button>
            </div>
            <div className="space-y-4 text-[#6B4B3E]" data-id="element-1061">
              <p data-id="element-1062">
                <strong data-id="element-1063">Main Character:</strong>{' '}
                {userInput.character.description}
              </p>
              <p data-id="element-1064">
                <strong data-id="element-1065">Story Beginning:</strong>{' '}
                {userInput.structure.beginning}
              </p>
              <p data-id="element-1066">
                <strong data-id="element-1067">Main Event:</strong> {userInput.structure.middle}
              </p>
              <p data-id="element-1068">
                <strong data-id="element-1069">Ending:</strong> {userInput.structure.ending}
              </p>
            </div>
          </div>
          {/* Story Bunny's Suggestions */}
          <div className="bg-white border-2 border-[#E5C1A9] rounded-xl p-6" data-id="element-1070">
            <div className="flex items-center space-x-3 mb-4" data-id="element-1071">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dgYPmgQZXQdrKaC8NJmmVJ/ChatGPT_Image_May_18%2C_2025_at_09_37_05_AM.png" alt="Story Bunny" className="w-8 h-8" data-id="element-1072" />
              <h3 className="text-lg font-bold text-[#6B4B3E]" data-id="element-1073">
                Story Bunny's Suggestions
              </h3>
            </div>
            <div className="space-y-4 text-[#6B4B3E]" data-id="element-1074">
              <div data-id="element-1075">
                <p className="font-medium mb-2" data-id="element-1076">Suggested Title:</p>
                <p className="bg-[#FFF0E6] p-3 rounded-lg" data-id="element-1077">
                  {aiSuggestions.title}
                </p>
              </div>
              <div data-id="element-1078">
                <p className="font-medium mb-2" data-id="element-1079">Character Development:</p>
                <p className="bg-[#FFF0E6] p-3 rounded-lg" data-id="element-1080">
                  {aiSuggestions.character}
                </p>
              </div>
              <div data-id="element-1081">
                <p className="font-medium mb-2" data-id="element-1082">Story Development:</p>
                <p className="bg-[#FFF0E6] p-3 rounded-lg" data-id="element-1083">
                  {aiSuggestions.plot}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-4 mt-8" data-id="element-1084">
          <button onClick={onClose} className="px-6 py-3 rounded-full border-2 border-[#E5C1A9] text-[#6B4B3E] hover:bg-[#FFF0E6] transition-colors" data-id="element-1085">
            Keep Editing
          </button>
          <button onClick={onConfirm} className="px-6 py-3 bg-[#D4A088] text-white rounded-full hover:bg-[#C28B73] transition-colors flex items-center" data-id="element-1086">
            <SparklesIcon size={20} className="mr-2" data-id="element-1087" />
            Create Story
          </button>
        </div>
      </div>
    </div>;
};